let dirAudio = 'games/page038_game0/audio/';

let elements = {
  //pick: 3,
  blockCheck: true,
  permanent: true,
  mainImage: {
    imagePath: 'games/page038_game0/img/bcg1.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page038_game0/audio/false.mp3',
    positive: 'games/page038_game0/audio/53_fish.mp3',
    click: 'games/page038_game0/audio/click.mp3',
    icon: {
      on: 'games/page038_game0/img/audioOn.png',
      off: 'games/page038_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 48,
    height: 48,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 493,
    height: 503,
  },
  layoutItems: [
    {
      pos: {
        x: 620,
        y: 627,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 1380,
        y: 193,
      },
    },
    {
      pos: {
        x: 1013,
        y: 193,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page038_game0/audio/53_fish.mp3',
          correct: {
            image: {
              src: 'games/page038_game0/img/ryba.webp',
            },
            width: 493,
            height: 503,
            correctItems: {
              images: [
                {
                  src: 'games/page038_game0/img/rybaok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 493,
                  height: 503,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page038_game0/img/chomik.webp',
            },
            width: 493,
            height: 503,
            incorrectItems: {
              images: [
                {
                  src: 'games/page038_game0/img/chomikwr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 493,
                  height: 503,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  staticMaskConfig: [
    {
      id: 'm1',
      pos: {
        y: 267,
        x: 576,
      },
      unit: 'px',
      click: { src: dirAudio + 'click.mp3' },
      src: 'games/page038_game0/img/folia.webp',
    },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page038_game0/audio/53_fish.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page038_game0/img/audioOn.png', iconOff: 'games/page038_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 626,
        x: 622,
      },
      unit: 'px',
    },
  ],
};

export default elements;
